"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getKeysDeep = exports.formatTimespan = exports.getSignature = exports.getInvoiceAddress = exports.getAddressVariables = exports.getAnredeBrief = exports.getUnits = exports.getUnit = exports.formatDate = exports.ensureDate = void 0;
function ensureDate(date) {
    if (date == null)
        return null;
    const parsedDate = date instanceof Date ? date : new Date(date);
    return isNaN(parsedDate.getTime()) ? null : parsedDate;
}
exports.ensureDate = ensureDate;
function formatDate(date) {
    const parsedDate = ensureDate(date);
    if (!parsedDate)
        return "";
    return parsedDate.toLocaleDateString("de-DE", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
    });
}
exports.formatDate = formatDate;
function getUnit(unit) {
    var _a;
    return (_a = (unit ? getUnits()[unit] : null)) !== null && _a !== void 0 ? _a : "Stk.";
}
exports.getUnit = getUnit;
function getUnits() {
    return {
        kilogram: "kg",
        meter: "m",
        piece: "Stk.",
    };
}
exports.getUnits = getUnits;
function getAnredeBrief({ formOfAddress, lastname }) {
    if (lastname && formOfAddress) {
        if (formOfAddress === "Herr") {
            return `Sehr geehrter Herr ${lastname},`;
        }
        else if (formOfAddress === "Frau") {
            return `Sehr geehrte Frau ${lastname},`;
        }
    }
    return "Sehr geehrte Damen und Herren,";
}
exports.getAnredeBrief = getAnredeBrief;
function getAddressVariables(address) {
    var _a, _b, _c;
    if (address == null) {
        return {};
    }
    return {
        anrede: address.formOfAddress === "Firma"
            ? address.company
            : address.formOfAddress === "Herr"
                ? "Herrn"
                : (_a = address.formOfAddress) !== null && _a !== void 0 ? _a : "",
        firma: address.company || "",
        istFirma: address.formOfAddress === "Firma" ? 1 : 0,
        name: `${address.firstname || ""} ${address.lastname || ""}`.trim(),
        vorname: address.firstname || "",
        nachname: address.lastname || "",
        anschrift: address.address.split("\n")[0] || "",
        anschrift2: address.address.split("\n")[1] || "",
        plz: address.zipCode || "",
        ort: address.city || "",
        anredeBrief: getAnredeBrief(address),
        telefon: (_b = ("phoneNumber" in address ? address.phoneNumber : "")) !== null && _b !== void 0 ? _b : "",
        etage: (_c = ("floor" in address ? address.floor : "")) !== null && _c !== void 0 ? _c : "",
    };
}
exports.getAddressVariables = getAddressVariables;
function getInvoiceAddress(move) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q;
    switch (move.invoiceAddressType) {
        case "customerAddress":
            return move.customer;
        case "unloadingAddress":
            return (_a = move.unloadingAddresses[0]) !== null && _a !== void 0 ? _a : move.customer;
        case "other":
            return {
                formOfAddress: (_c = (_b = move.invoiceAddress) === null || _b === void 0 ? void 0 : _b.formOfAddress) !== null && _c !== void 0 ? _c : "",
                address: (_e = (_d = move.invoiceAddress) === null || _d === void 0 ? void 0 : _d.address) !== null && _e !== void 0 ? _e : "",
                city: (_g = (_f = move.invoiceAddress) === null || _f === void 0 ? void 0 : _f.city) !== null && _g !== void 0 ? _g : "",
                firstname: (_j = (_h = move.invoiceAddress) === null || _h === void 0 ? void 0 : _h.firstname) !== null && _j !== void 0 ? _j : "",
                lastname: (_l = (_k = move.invoiceAddress) === null || _k === void 0 ? void 0 : _k.lastname) !== null && _l !== void 0 ? _l : "",
                zipCode: (_o = (_m = move.invoiceAddress) === null || _m === void 0 ? void 0 : _m.zipCode) !== null && _o !== void 0 ? _o : "",
                company: (_q = (_p = move.invoiceAddress) === null || _p === void 0 ? void 0 : _p.company) !== null && _q !== void 0 ? _q : "",
            };
        default:
            return move.customer;
    }
}
exports.getInvoiceAddress = getInvoiceAddress;
function getSignature(consultant) {
    return `${consultant.signaturePrefix} ${consultant.fullName}`.trim();
}
exports.getSignature = getSignature;
function formatTimespan(date, deltaMinutes) {
    return `${date.toLocaleTimeString("de-DE", {
        hour: "2-digit",
        minute: "2-digit",
    })} bis ${new Date(date.getTime() + deltaMinutes * 60 * 1000).toLocaleTimeString("de-DE", { hour: "2-digit", minute: "2-digit" })} Uhr`;
}
exports.formatTimespan = formatTimespan;
function getKeysDeep(obj) {
    const keys = [];
    for (const [key, value] of Object.entries(obj)) {
        if (typeof value === "object") {
            keys.push(...getKeysDeep(value).map((k) => `${key}.${k}`));
        }
        else {
            keys.push(key);
        }
    }
    return keys;
}
exports.getKeysDeep = getKeysDeep;
//# sourceMappingURL=util.js.map